import React from 'react';
import WelcomeSection from './components2/WelcomeSection';
import ExploreModleeAgent from './components2/ExploreModleeAgent';
import CallToActionForm from './components2/CallToActionForm';
import HiddenCosts from './components2/HiddenCosts';
import ValueComparison from './components2/ValueComparison';
import DecisionAgentInstructions from './components2/DecisionAgentInstructions';



import './App.css';

function App() {

  return (
    <div className="app-container">
      <Navbar />
      <WelcomeSection />
      <HiddenCosts />
      <ExploreModleeAgent />
      <ValueComparison />
      <CallToActionForm />
    </div>
  );
}

function Navbar() {
  return (
    <nav className="navbar">
      <div className="logo">
        <a href="https://www.modlee.ai" target="_blank" rel="noopener noreferrer">
          <img src={`${process.env.PUBLIC_URL}/logo-modlee.svg`} alt="Modlee Logo" />
        </a>
      </div>

      {/* <div className="nav-links">
        <a href="https://www.modlee.ai" target="_blank" rel="noopener noreferrer">Package</a>
        <a href="https://www.modlee.ai/consulting" target="_blank" rel="noopener noreferrer">AI Consulting</a>
      </div> */}
    </nav>
  );
}

export default App;
